import './styles/TestExecution.scss';

import { useClassHelper } from '@whistler-ui/k2/hooks';
import { useState } from 'react';

import { TestTabs } from '../../constants';
import {
  TTestTabs,
  TUseCasesApiTags,
  TUseCaseTags,
  TUseCaseType,
} from '../../types';
import { TestDetails } from '../TestDetails';
import { TestTable } from './components/TestTable';

const componentName = 'c-TestExecution';

export type TTest = {
  test_case: {
    [key: string]: any;
  };
  api_test_execution: {
    [key: string]: any;
  };
};

interface Props {
  title: string;
  tag: string;
  tests: TTest[];
  type: TUseCaseType;
  handleRunTest: (testCaseTag: string) => void;
}

export const TestExecution: React.FC<Props> = ({
  title,
  type,
  tag,
  tests = [],
  handleRunTest,
}: Props) => {
  const c = useClassHelper(componentName);
  const [activeRow, setActiveRow] = useState(0);
  const [activeContent, setActiveContent] = useState<TTestTabs>(
    TestTabs.OVERVIEW,
  );
  const detailsTabs = [TestTabs.OVERVIEW, TestTabs.CONSOLE, TestTabs.TEST_DATA];

  const setActiveTableRow = (index: number) => {
    setActiveRow(index);
  };

  const onRunTest = (event: React.MouseEvent<HTMLButtonElement>) => {
    const tag = event.currentTarget.getAttribute('data-tag');
    handleRunTest(tag);
  };

  return (
    <div className={componentName}>
      <div className={c('__title-row')}>
        <h3 className={c('__title')}>{title}</h3>
      </div>
      {tests && (
        <div className={c('__container')}>
          <div className={c('__row-container')}>
            <div className={c('__table')}>
              <TestTable>
                {tests.map((test, index) => {
                  return (
                    <TestTable.Item
                      key={index}
                      index={index + 1}
                      title={test.test_case.title}
                      testTag={test.test_case.tag}
                      tag={tag}
                      isActive={activeRow === index}
                      type={type}
                      data-tag={test.test_case.tag}
                      onRunTest={onRunTest}
                      handleOnSelect={() => setActiveTableRow(index)}
                    />
                  );
                })}
              </TestTable>
            </div>
            <div className={c('__content')}>
              <TestDetails
                setActiveContent={content => setActiveContent(content)}
                tabs={detailsTabs}
                activeContent={activeContent}
                testCase={tests[activeRow]?.test_case}
                type={type}
                tag={tag as TUseCaseTags | TUseCasesApiTags}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
